import React from "react";

const About: React.FC = () => {
  return (
    <div className="home-container">
      <div className="container">
        <h1>About EngiCalc</h1>
        <p>EngiCalc is a tool designed for engineers and construction professionals.</p>
      </div>
    </div>
  );
};

export default About;
